import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=133d76cd&scoped=true"
import script from "./AppIcon.vue?vue&type=script&lang=js"
export * from "./AppIcon.vue?vue&type=script&lang=js"
import style0 from "./AppIcon.vue?vue&type=style&index=0&id=133d76cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133d76cd",
  null
  
)

export default component.exports